// Currently we assume that Copernicus may provide flood depths in the following ranges only, but this may change in the future.
// The names in this syntax, "0.00 - 0.50" come from Copernicus shape files.
// We assume that not all depth files are present in data set from Copernicus, but only some of them.
// The file EMSR???\AOI??\flood_depths_sorted_names.json may typically contain
/*
{
    "sorted_names": [
        "flood_depths_0.00 - 0.50",
        "flood_depths_0.50 - 1.00",
        "flood_depths_1.00 - 2.00",
        "flood_depths_2.00 - 4.00",
        "flood_depths_4.00 - 6.00"
    ]
}

or

{
    "sorted_names": []
}
*/

// Geojson files are named "flood_depths_0.00 - 0.50.geojson", "flood_depths_0.50 - 1.00.geojson", etc.
// It is possible that depth files are missing at all, for older events.
// Colors are used for geojson layer styling and for the legend.
// Layers of the geojson files must be rendered strictly in the order of the sorted_names array, without any transparency.

export type DepthName =
  | "flood_depths_0.00 - 0.50"
  | "flood_depths_0.50 - 1.00"
  | "flood_depths_1.00 - 2.00"
  | "flood_depths_2.00 - 4.00"
  | "flood_depths_4.00 - 6.00";

type DepthColorsDict = {
  [key in DepthName]: string;
};

export const depthColorsDict: DepthColorsDict = {
  // From light blue to dark blue
  "flood_depths_0.00 - 0.50": "#2296F3",
  "flood_depths_0.50 - 1.00": "#1f76c3",
  "flood_depths_1.00 - 2.00": "#1a56a3",
  "flood_depths_2.00 - 4.00": "#103673",
  "flood_depths_4.00 - 6.00": "#051643",
};

export const depthNamesSorted: DepthName[] = Object.keys(depthColorsDict).sort() as DepthName[];

export const removeSubstringFloodDepth = (name: DepthName): string => {
  return name.replace("flood_depths_", "");
};

export const getDepthNamesPathsColors = async (
  cloudfrontUrl: string,
  subdirectory: string,
  activationCode: string,

  s3AoiFolder: string,
) => {
  const depthNamesJsonFilePath = `${subdirectory}/${activationCode}/${s3AoiFolder}/flood_depths_sorted_names.json`;
  const response = await fetch(cloudfrontUrl + depthNamesJsonFilePath);
  const depthNames = await response.json();
  const depthSortedNames: DepthName[] = depthNames.sorted_names;

  return {
    depthNames: depthSortedNames,
    depthColors: depthSortedNames.map((depthName: DepthName) => depthColorsDict[depthName]),
    depthFilePaths: depthSortedNames.map(
      (depthName: DepthName) =>
        cloudfrontUrl + `${subdirectory}/${activationCode}/${s3AoiFolder}/${depthName}.geojson`,
    ),
  };
};
